const validateExists = (x) =>
  typeof x !== 'undefined' ? '' : 'Please provide a value'

export default validateExists
